// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l8_jD","left":"styles_left__3frQW"};